// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__33aZS","body":"styles_body__6I1M-","main":"styles_main__ybOR5"};